import React from 'react';
import { Button, Paper, Box } from '@mui/material';
import { usePageLevelVideoConfigContext } from '../../../../../../Contexts/PageLevelVideoConfigContext';
import useStyles from './styles';

import { Grid } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Pagination from '@mui/material/Pagination';
import { PLAYLIST_MODES } from '../../../../../../core/constants';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import SinglePageConfig from './Components/SinglePageConfig';

const PageLevelVideoConfigGenerator = () => {
	const classes = useStyles();
	const {
		playlistConfigData,
		playlistConfigMode,
		handlePlaylistConfigAddPage,
		deletePlaylistConfigPage,
		savePlaylistConfigPages,
		playlistConfigPage,
		setPlaylistConfigPage,
		setPlaylistConfigMode,
		setPlaylistConfigError
	} = usePageLevelVideoConfigContext();

	const handleSavePage = async () => {
		await savePlaylistConfigPages();
	};

	const handleChange = (event, value) => {
		setPlaylistConfigPage(value);
	};

	if (!playlistConfigData) {
		setPlaylistConfigError(true);
	}

	const isCurrentPlaylistPageDeletable = () => {
		return !!playlistConfigData?.[playlistConfigPage - 1]?.isDeletable;
	};

	const handleBackArrowButtonClick = () => {
		if (playlistConfigMode === PLAYLIST_MODES.CREATE_PAGE_VIDEOS)
			setPlaylistConfigMode(PLAYLIST_MODES.SITE_LEVEL_CREATE_PAGE_VIDEOS);
		else setPlaylistConfigMode(PLAYLIST_MODES.SITE_LEVEL_UPDATE_PAGE_VIDEOS);
	};
	return (
		playlistConfigData && (
			<Paper className={classes.container}>
				<Grid container spacing={2}>
					<Grid item xs={1}>
						<ArrowBackIcon
							color="primary"
							fontSize="large"
							style={{ cursor: 'pointer' }}
							onClick={handleBackArrowButtonClick}
						/>
					</Grid>
					<Grid item xs={5}>
						<Pagination
							count={playlistConfigData.length}
							shape="rounded"
							page={playlistConfigPage}
							onChange={handleChange}
						/>
					</Grid>
					<Grid item xs={6} className={classes.buttonWrapper}>
						<Button variant="contained" onClick={handlePlaylistConfigAddPage}>
							Add Page
						</Button>
						{playlistConfigData.length > 0 && isCurrentPlaylistPageDeletable() ? (
							<Button
								variant="contained"
								onClick={() =>
									deletePlaylistConfigPage(playlistConfigData[playlistConfigPage - 1].id)
								}
							>
								Delete Page
							</Button>
						) : null}

						<Button variant="contained" onClick={handleSavePage}>
							Save Config
						</Button>
					</Grid>
				</Grid>
				<Box className={classes.wrapper}>
					{playlistConfigData.length > 0 ? (
						<SinglePageConfig
							key={playlistConfigData[playlistConfigPage - 1].id}
							config={playlistConfigData[playlistConfigPage - 1]}
						/>
					) : null}
				</Box>
				<ToastContainer />
			</Paper>
		)
	);
};

export default PageLevelVideoConfigGenerator;
